import { useCart } from '../../hooks/useCart'

import { currency } from '../../helpers/currency_fomat'
import { SnackEskeleton } from './SnackEskeleton'
// import { ReactComponent as Pencil } from '../../assets/pencil.svg'

import * as Styled from './styles'

export interface SnackData {
  id: string | number
  snack: string
  name: string
  image: string
  description: string
  price: number
}

interface SnackProps {
  snacks: SnackData[]
}

export const Snacks = ({ snacks }: SnackProps) => {
  const { cart, addSnackCart } = useCart()
  return (
    <Styled.Container>
      {!snacks.length
        ? [1, 2, 3, 4].map((n) => <SnackEskeleton key={n} />)
        : snacks.map((item) => {
            const snackExistCart = cart.find((c) => item.id === c.id && item.snack === c.snack)

            return (
              <div key={item.id} className='snack'>
                {/* <Pencil /> */}
                {snackExistCart && <span>{snackExistCart.quantity}</span>}
                <h2>{item.name}</h2>
                <img src={item.image} alt='' />
                <p>{item.description}</p>
                <div>
                  <strong>{currency(item.price)}</strong>
                  <button onClick={() => addSnackCart(item)}>+</button>
                </div>
              </div>
            )
          })}
    </Styled.Container>
  )
}
